export const isIPhone = () => /iPhone|iPad/i.test(navigator.userAgent);
